import { Radio, RadioGroup } from "@blueprintjs/core";
import { PaymentRequestButtonElement } from "@stripe/react-stripe-js";
import { PaymentRequest } from "@stripe/stripe-js";

import { Box } from "@/components/layout/flexbox";
import { PaymentMethod } from "@/types/products";

import { getCardBrandDisplayName } from "./constants";
import { NewPaymentMethodForm } from "./NewPaymentMethodForm";

interface CardSelectorProps {
  paymentMethods: PaymentMethod[];
  paymentRequest?: PaymentRequest;
  selectedMethodId?: string;
  setSelectedMethodId: (methodId: string) => void;
  billingName: string;
  setBillingName: (name: string) => void;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

export function CardSelector({
  paymentMethods,
  paymentRequest,
  selectedMethodId,
  setBillingName,
  handleSubmit,
  setSelectedMethodId,
  billingName,
}: CardSelectorProps) {
  return (
    <Box
      className="bas round-corners"
      backgroundColor="#FFF"
      pt={24}
      pb={3}
      px={[3, 24]}
    >
      {paymentRequest ? (
        <Box mb={24} maxWidth={300}>
          <PaymentRequestButtonElement options={{ paymentRequest }} />
        </Box>
      ) : null}
      <RadioGroup
        onChange={(e) => setSelectedMethodId(e.currentTarget.value)}
        selectedValue={selectedMethodId}
      >
        {paymentMethods &&
          paymentMethods.map((method) => (
            <Radio
              labelElement={
                <>
                  <b>{getCardBrandDisplayName(method.brand)}</b> ending in{" "}
                  {method.last4}
                </>
              }
              large={true}
              value={method.stripeId ?? undefined}
              key={method.stripeId}
            />
          ))}
        <Radio
          large={true}
          key={`add-new-method`}
          labelElement={<b>Add new card</b>}
          value="NEW"
        />
      </RadioGroup>
      {selectedMethodId === "NEW" ? (
        <NewPaymentMethodForm
          billingName={billingName}
          setBillingName={setBillingName}
          handleSubmit={handleSubmit}
        />
      ) : null}
    </Box>
  );
}
